import { Component, OnInit } from '@angular/core';
import { RestApiService } from '../../rest-api.service';
import { BaseInventoryComponent } from '../base-inventory/base-inventory.component';

@Component({
  selector: 'app-past-inventory',
  templateUrl: './past-inventory.component.html',
  styleUrls: ['./past-inventory.component.css']
})
export class PastInventoryComponent extends BaseInventoryComponent implements OnInit {

  constructor(public restApi: RestApiService) {
    super(restApi);
    this.getInventoryEndpoint = restApi.getPastWorks;
  }

  ngOnInit() {
    super.ngOnInit();
  }

}
